/* istanbul ignore file */
import { LogLevels } from '../logging/types/LogLevels';
import { getRegionString, Region } from './Region';
import { v4 as uuidv4 } from 'uuid';

const win = window as any;

export interface AppSettings {
    clientId: string;
    clientSecret: string;
    clientIdentity: string;
    sessionId: string;
    region: Region;
    logLevel: LogLevels;
    enableServerLogging: boolean;
    enablePrescriptionTracker: boolean;
}

let settings = {} as AppSettings;

export function loadAppSettings() {
    const urlSettings = getSettingsFromUrl();
    settings = {
        clientId: urlSettings.clientId || 'ReactClient',
        region: urlSettings.region || 'England',
        logLevel: win.clientSettings.logLevel,
        enableServerLogging: win.clientSettings.enableServerLogging,
        sessionId: uuidv4(),
        enablePrescriptionTracker: urlSettings.enablePrescriptionTracker,
        clientSecret: '',
        clientIdentity: ''
    };
}

export function setClientCredentials(clientCredentials: string) {
    settings.clientSecret = clientCredentials.split(':')[1];
    settings.clientIdentity = clientCredentials.split(':')[0];
}

interface UrlSettings {
    clientId: string;
    region?: Region;
    enablePrescriptionTracker: boolean;
}

function getSettingsFromUrl(): UrlSettings {
    const urlParams = new URLSearchParams(window.location.search);
    const region = urlParams.get('region');
    const clientId = urlParams.get('clientId') || '';
    const enablePrescriptionTracker = urlParams.get('EnablePrescriptionTracker') !== 'False';

    return {
        region: region ? getRegionString(parseInt(region as string, 10)) : undefined,
        enablePrescriptionTracker,
        clientId
    };
}

export function getAppSettings(): AppSettings {
    return settings;
}

export function getAppSettingsAsString() {
    const parts: string[] = [];
    for (const i in settings) {
        if (settings.hasOwnProperty(i)) {
            if (i === 'clientSecret') {
                continue;
            } else {
                // @ts-ignore
                parts.push(`${i}:${settings[i]}`);
            }
        }
    }

    return parts.join(' ');
}
